import React, { useState, useEffect, useRef } from "react";
import "../../Masterclass.css";
import Header from "../components/Header";
import Footer from "../components/Footer";
import configData from "../../config.json";
<link
  href="https://fonts.googleapis.com/css2?family=Poppins:wght@500;600;700&display=swap"
  rel="stylesheet"
/>

export default function Callwithcounselor() {
  const [countdown, setCountdown] = useState("");

  useEffect(() => {
    const end = new Date();
    end.setHours(end.getHours() + 1);

    const timer = setInterval(() => {
      const now = new Date();
      const diff = end - now;
      if (diff <= 0) return setCountdown("Offer Ended");

      const h = String(Math.floor(diff / (1000 * 60 * 60))).padStart(2, "0");
      const m = String(Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60))).padStart(2, "0");
      const s = String(Math.floor((diff % (1000 * 60)) / 1000)).padStart(2, "0");

      setCountdown(`${h}:${m}:${s}`);
    }, 1000);

    return () => clearInterval(timer);
  }, []);



  useEffect(() => {
    const isPaidUser = localStorage.getItem("isPaidUser");
    if (isPaidUser === "true") return;

    if (!window.Calendly) {
      const script = document.createElement("script");
      script.src = "https://assets.calendly.com/assets/external/widget.js";
      script.async = true;
      document.body.appendChild(script);
    }
  }, []);

  const openCalendlyPopup = () => {
    if (window.Calendly) {
      window.Calendly.initPopupWidget({
        url: "https://calendly.com/myprega/30min",
      });
    }
  };


  useEffect(() => {
    const handleCalendlyEvent = (e) => {
      if (e.data.event === "calendly.event_scheduled") {
        console.log("Calendly b....k completed");

        if (window.fbq) {
          window.fbq("track", "CompleteRegistration");
        }
        // window.location.href = "/MasterclassThankYouPage";
      }
    };

    window.addEventListener("message", handleCalendlyEvent);
    return () => {
      window.removeEventListener("message", handleCalendlyEvent);
    };
  }, []);


  return (
    <div className="page" style={{ paddingBottom: "130px" }}>
      <Header />
      <section className="hero" style={{ marginTop: "36px" }}>
        <div className="hero-grid">

          <div className="hero-content">
            <h1
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 600
              }}
            >
              Are You 100% Sure Your Pregnancy Is on the Right Track?
            </h1>

            <h1
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontWeight: 400
              }}
            >
              Most moms miss early warning signs — until it’s too late.
            </h1>

            <p className="trust-text" style={{ fontSize: "22px", color: "#4300ff", fontWeight: "bold" }}>Get a <span style={{ fontWeight: "bolder" }}>Free Personalized Pregnancy Roadmap Session (Worth ₹2,500) </span>to uncover hidden
              risks in your current pregnancy care and get a clear, step-by-step safety blueprint..
            </p>

            <button className="primary-btn" onClick={openCalendlyPopup}>
              Reserve My Free 1:1 Session
            </button>

            <span className="trust-text1" style={{ fontWeight: "bold", color: "#ff0e9e" }}>
              Designed by senior gynecologists & pregnancy experts — trusted by 1000+ of moms.
            </span>
          </div>

          <div className="hero-section">
            <div style={{ width: "100%", }}>
              <img src="/Callwithcounselor0.png" alt="Hero" />
            </div>
          </div>
        </div>
      </section>


      <section className="why-matters">
        <div className="container why-grid">
          <div className="why-image">
            <img src="/Callwithcounselor1.png" alt="Why this matters" />
          </div>
          <div className="why-content">
            {/* <h2 style={{
                 fontFamily: "'Poppins', sans-serif",
               }}>Why This Matters</h2> */}

            <p>
              You’re doing everything right — following your doctor’s advice, taking supplements, attending
              scans. But between those monthly visits,<span style={{ fontWeight: "bolder" }}> who’s tracking your BP, sugar, stress, sleep, or
                baby growth daily?</span>
            </p>

            <p>
              That’s where small unnoticed issues begin — and turn into complications later.
              This free session helps you <span style={{ fontWeight: "bolder" }}>spot those hidden risks early </span>— before they become problems.
            </p>

          </div>

        </div>
      </section>

      <section className="section light">
        <h3 className="section-title"
          style={{
            fontFamily: "'Poppins', sans-serif",
          }}>What Happens in the Free Pregnancy Roadmap Session</h3>
        <p style={{ textAlign: "center", paddingTop: "10px", fontWeight: "bold" }}>
          In your 30-minute private call with our expert pregnancy counsellor:
        </p>


        <div className="steps">
          <div className="step">
            <span> <span style={{ fontWeight: "bolder" }}>We’ll review your pregnancy journey so far </span>— your lifestyle, tests, scans, and care
              pattern.</span>
          </div>

          <div className="step">
            <span> <span style={{ fontWeight: "bolder" }}>We’ll identify hidden risks and gaps </span>— in your current pregnancy care — things most
              moms don’t realize until it’s late.</span>
          </div>

          <div className="step">
            <span> <span style={{ fontWeight: "bolder" }}>We’ll design your personalized “Pregnancy Safety Blueprint” </span>— — so you know
              exactly what to track, when, and how to stay in control.</span>
          </div>


          <div className="step">
            <span><span style={{ fontWeight: "bolder" }}>This structure is similar to what senior doctors follow during medical case reviews. </span></span>
          </div>
        </div>

        <p style={{ textAlign: "center", paddingTop: "20px", fontWeight: "bold", color: "#ff00aa" }}>
          No pitching. No selling. Just genuine, expert guidance — completely free.
        </p>
      </section>


      <section className="who-for">
        <div className="container">
          <h2 style={{
            fontFamily: "'Poppins', sans-serif",
          }}>Who This Call Is For</h2>

          <div className="compare-box">
            <div
              style={{
                display: "flex",
                flexWrap: "wrap",
                gap: "20px",
                width: "100%"
              }}
            >
              <div
                className="box positive"
                style={{
                  flex: "1 1 30%",
                  minWidth: "300px"
                }}
              >
                <h3 style={{ fontWeight: "700" }}>● This session is perfect for you if:</h3>
                <ul>
                  <li>You want to ensure your pregnancy is<span style={{ fontWeight: "bolder" }}>who don’t want to waste time on low-quality advice</span></li>
                  <li>You often wonder if your current care covers everything</li>
                  <li>You’ve experienced <span style={{ fontWeight: "bolder" }}>BP, sugar, stress, or sleep issues</span> lately</li>
                  <li> You want to know how to <span style={{ fontWeight: "bolder" }}> prevent complications early</span></li>
                  <li>You believe in being proactive, not reactive, about your baby’s health</li>
                </ul>
              </div>

            </div>
          </div>
        </div>
      </section>

      <section className="expect-section">
        <h3 className="section-title" style={{
          fontFamily: "'Poppins', sans-serif",
        }}>Why This Call Is So Valuable</h3>

        <p style={{ textAlign: "center", paddingTop: "20px", fontWeight: "bold" }}>
          Most moms wait until something feels wrong. But during this call, our experts analyze your
          case like a medical review — finding small gaps that can prevent big risks.
        </p>

        <div className="expect-grid">
          <div className="expect-card">
            <img src="/Callwithcounselorwhy0.png" alt="Risks" className="card-icon" />
            <h4> Personalized report prepared for your pregnancy</h4>
          </div>

          <div className="expect-card">
            <img src="/Callwithcounselorwhy1.png" alt="Development" className="card-icon" />
            <h4>Expert counsellor trained by doctors — not sales agents</h4>
          </div>

          <div className="expect-card">
            <img src="/Callwithcounselorwhy2.png" alt="Framework" className="card-icon" />
            <h4>Honest, data-driven recommendations</h4>
          </div>

          <div className="expect-card">
            <img src="/Callwithcounselorwhy3.png" alt="Expert" className="card-icon" />
            <h4>₹2,500 value — free this week only</h4>
          </div>

          <div className="expect-card">
            <img src="/Callwithcounselorwhy4.png" alt="Call" className="card-icon" />
            <h4> 20 sessions available — first come, first served</h4>
          </div>
        </div>
        <p style={{ textAlign: "center", paddingTop: "30px", fontWeight: "bold", color: "#ff00aa" }}>
          You never get this much time with a doctor in a hospital — this session is your chance to
          understand everything deeply.
        </p>
      </section>

      <section className="final-cta">
        <div className="final-cta-wrap">

          <div className="final-cta-img">
            <img src="/Callwithcounselor2.png" alt="Final CTA" />
          </div>

          <div className="final-cta-content">
            <h2 style={{
              fontFamily: "'Poppins', sans-serif", paddingBottom: "20px", color: "black"
            }}>100% Genuine, No Hidden Sales Pitch</h2>

            <h3>
              We know what you’re thinking: “Is this just another marketing trick?”
              No. This is <span style={{ fontWeight: "bolder" }}>not a sales call</span>. This is a <span style={{ fontWeight: "bolder" }}>medical-grade counselling session</span>, designed by
              pregnancy experts to help you understand your current pregnancy health better.
              Your counsellor’s goal is not to sell — it is to protect your pregnancy.
            </h3>

            <h3 style={{ marginTop: "10px", color: "#ff008e" }}>
              Relax — your call is NOT a sales pitch.<br />
              <span style={{ fontWeight: "bolder" }}>
                💯 Zero pressure. Zero obligation. Zero promotion
              </span>
            </h3>
            <button className="primary-btn" onClick={openCalendlyPopup}>
              Reserve My Free sessions Now
            </button>
          </div>
        </div>

        <div
          style={{
            position: "fixed",
            bottom: 0,
            left: 0,
            width: "100%",
            background: "#ffffff",
            padding: "12px 16px 16px",
            zIndex: 9999,
            boxShadow: "0 -4px 12px rgba(0,0,0,0.12)",
            textAlign: "center"
          }}
        >

          <div
            style={{
              fontSize: "15px",
              fontWeight: "600",
              color: "#0f172a",
              marginBottom: "10px"
            }}
          >
            ⚡ <span style={{ fontWeight: "700" }}>Only 20 free sessions available this week</span>
          </div>

          <button
            onClick={openCalendlyPopup}
            style={{
              width: "100%",
              maxWidth: "680px",
              background: "linear-gradient(90deg, #ff008e, #ff4fb8)",
              color: "#fff",
              border: "none",
              padding: "16px",
              borderRadius: "14px",
              fontSize: "18px",
              fontWeight: "700",
              cursor: "pointer",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              gap: "10px",
              margin: "0 auto"
            }}
          >
            Reserve yours now
            <span
              style={{
                textDecoration: "line-through",
                opacity: 0.9,
                fontWeight: "500",
                fontWeight: "bolder"
              }}
            >
              ₹2,500
            </span>
            FREE
          </button>
        </div>

      </section>

      <div
        style={{
          width: "100%",
          padding: "60px 20px",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#fff",
        }}
      >
        <div
          style={{
            maxWidth: "1200px",
            width: "100%",
            display: "flex",
            alignItems: "center",
            gap: "40px",
            flexWrap: "wrap-reverse",
          }}
        >

          <div
            style={{
              flex: "1 1 400px",
            }}
          >
            <h2
              style={{
                fontFamily: "'Poppins', sans-serif", paddingBottom: "20px", fontSize: "32px", color: "black"
              }}
            >
              Real Moms Who Took This Session Said...
            </h2>

            {[
              {
                text:
                  "I thought everything was fine until this call showed small risks in my BP pattern. Now I know exactly what to track.",
                name: "Aditi, Pune",
              },
              {
                text:
                  "I didn’t realize how many small things I was ignoring. The roadmap gave me so much peace.",
                name: "Neha, Mumbai",
              },
              {
                text:
                  "Honestly, it didn’t feel like a sales call at all. The counsellor was calm, kind, and explained things my doctor never did.",
                name: "Prerna, Bangalore",
              },
            ].map((item, index) => (
              <div key={index} style={{ marginBottom: "22px" }}>
                <p style={{ fontSize: "20px", lineHeight: "1.7" }}>
                  “{item.text}”
                  <br />
                  <strong>— {item.name}</strong>
                </p>
                <div style={{ color: "#FFC107", fontSize: "18px", marginBottom: "6px" }}>
                  ★★★★★
                </div>


              </div>
            ))}
          </div>

          <div
            style={{
              flex: "1 1 350px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src="/Confirmation5.png"
              alt="Happy Mom"
              style={{
                width: "100%",
                maxWidth: "100%",
                height: "auto",
              }}
            />
          </div>
        </div>
      </div>


      <div
        style={{
          width: "100%",
          padding: "40px 20px",
          display: "flex",
          justifyContent: "center",
          backgroundColor: "#ffffff",
        }}
      >
        <div
          style={{
            maxWidth: "1500px",
            width: "100%",
            backgroundColor: "#173b59",
            borderRadius: "12px",
            padding: "30px",
            display: "flex",
            alignItems: "center",
            gap: "30px",
            flexWrap: "wrap",
          }}
        >

          <div
            style={{
              flex: "1 1 260px",
              display: "flex",
              justifyContent: "center",
            }}
          >
            <img
              src="/Callwithcounselor3.png"
              alt="Health Coach"
              style={{
                width: "100%",
                maxWidth: "420px",
                height: "auto",
              }}
            />
          </div>


          <div
            style={{
              flex: "2 1 400px",
              color: "#ffffff",
            }}
          >
            <h2
              style={{
                fontFamily: "'Poppins', sans-serif",
                fontSize: "32px", color: "white", paddingBottom: "28px"
              }}
            >
              Why Only 20 Free Sessions?
            </h2>

            <p
              style={{
                fontSize: "20px",
                lineHeight: "1.7",
                marginBottom: "12px",
                color: "white"
              }}
            >
              We keep these sessions limited so every mom gets genuine personal
              attention.
            </p>

            <p
              style={{
                fontSize: "20px",
                lineHeight: "1.7",
                marginBottom: "12px",
                color: "white"
              }}
            >
              Each roadmap is custom-built after analyzing your reports and symptoms —
              not a generic talk.
            </p>

            <p style={{ fontSize: "20px", lineHeight: "1.7", color: "white" }}>
              That’s why we open only <strong>20 free slots per week</strong>, and they
              usually fill within <strong>48 hours</strong>.
            </p>
          </div>
        </div>
      </div>


      <section className="offer">
        <div className="offer-inner">
          <div className="offer-image">
            <img src="/OfferSection.png" alt="Offer visual" />
          </div>

          <div className="offer-content" >
            <h2 style={{
              fontFamily: "'Poppins', sans-serif", paddingBottom: "20px", fontSize: "32px", color: "black"
            }}> Don’t Miss This Week’s Free Offer</h2>

            <p style={{ fontSize: "22px", color: "#5500ff", fontWeight: "bold" }}>
              This isn’t a random wellness call.
            </p>
            {/* <span className="strike">Regular value: ₹999</span> */}
            <p className="free" style={{ paddingBottom: "10px" }}>
              It’s a <span style={{ fontWeight: "bolder" }}>medical-backed pregnancy health review </span>— personalized for you.
              The ₹2,500 session is <span style={{ fontWeight: "bolder" }}>free only this week </span>for the first 20 moms-to-be.
            </p>
            <p style={{ fontSize: "22px", fontWeight: "bold" }}>
              Once these slots are filled, registration closes automatically
            </p>

            <p style={{ fontSize: "22px", fontWeight: "bold", paddingTop: "10px" }}>Pregnancy should never be a guessing game.
              Know your risks. Build your blueprint.
              Because prevention isn’t just smart — it’s love.</p>

            <button className="primary-btn" onClick={openCalendlyPopup}>
              Reserve My Free sessions Now – 20 free sessions available
            </button>

            <p className="free" style={{ paddingTop: "10px" }}>👉 Book your Free Pregnancy Roadmap Session today — before the 20 free slots close.</p>
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
